// Pricing — copied from flight-processor/index.html (getPrice / isRoutePriced).
//
// TWO DELIBERATE DIFFERENCES, both so the customer sees the same number on every device:
//
// 1. The rate / exchange / profit are CONSTANTS here. In the processor they are read out of the
//    calculator boxes, which load from localStorage — so the price a customer saw depended on
//    whose browser it was. These are the values a customer actually gets today (the HTML
//    defaults of calc1b / calc1d / calc1e), so nothing about customer pricing changes.
//
// 2. The per-airline manual override boxes are gone. Those are internal scratch values; a
//    customer was never meant to be quoted from them.

const RATE = 0.0022;        // miles -> dollars      (calc1b)
const FX = 1440;            // ARS per dollar        (calc1d)
const PROFIT = 65;          // economy; business +10 (calc1e)
const AZUL_RATE = 0.0052;   //                       (calc2b)
const AZUL_FX = 5.45;       //                       (calc2d)

export const DEFAULT_PRICE_RULES = [
      { name: 'Air Canada NY→Canada', origins: ['LGA', 'JFK', 'EWR'], destinations: ['YYZ', 'YUL', 'YTZ'], airline: 'Air Canada', economy: 110, business: 135 },
      { name: 'Air Canada Canada→NY', origins: ['YYZ', 'YUL', 'YTZ'], destinations: ['LGA', 'JFK', 'EWR'], airline: 'Air Canada', economy: 150, business: 180 },
      { name: 'American NY→Canada', origins: ['LGA', 'JFK', 'EWR'], destinations: ['YYZ', 'YUL', 'YTZ'], airline: 'American Airlines', economy: 135, business: 165 },
      { name: 'American Canada→NY', origins: ['YYZ', 'YUL', 'YTZ'], destinations: ['LGA', 'JFK', 'EWR'], airline: 'American Airlines', economy: 165, business: 210 },
      { name: 'Air Canada YYZ/YTZ→YUL', origins: ['YYZ', 'YTZ'], destinations: ['YUL'], airline: 'Air Canada', economy: 110, business: 135 },
      { name: 'Air Canada YUL→YYZ/YTZ', origins: ['YUL'], destinations: ['YYZ', 'YTZ'], airline: 'Air Canada', economy: 110, business: 135 },
    ];

// Is this route already covered by a preset price rule? (metro codes expanded.)
export function isRoutePriced(origin, destination) {
  const expand = c => { c = (c || '').toUpperCase(); const map = { YTO: ['YYZ', 'YTZ'], NYC: ['LGA', 'JFK', 'EWR'], YMQ: ['YUL'] }; return map[c] || [c]; };
  const os = expand(origin), ds = expand(destination);
  return DEFAULT_PRICE_RULES.some(r => os.some(o => r.origins.includes(o)) && ds.some(d => r.destinations.includes(d)));
}

export function getPrice(airline, classType, origin, destination, flight) {
  const isAzul = flight && flight.source === 'azul';

  // Preset route rules are Smiles-only (AC/AA booked via Smiles). Azul always auto-calcs.
  if (!isAzul) {
    const rule = DEFAULT_PRICE_RULES.find(r =>
      r.airline === airline &&
      r.origins.includes(origin && origin.toUpperCase()) &&
      r.destinations.includes(destination && destination.toUpperCase())
    );
    if (rule) {
      const price = rule[classType];
      if (price) return '$' + price;
    }
  }

  // No preset price -> auto-calculate from the flight's miles + its tax:
  // miles x rate + taxes(local) / exchange + profit.
  if (flight && flight.taxARS != null) {
    const rate = isAzul ? AZUL_RATE : RATE;
    const fx = isAzul ? AZUL_FX : FX;
    const profit = /business/i.test(classType) ? PROFIT + 10 : PROFIT;
    const miles = flight.milesClub || flight.miles || 0;
    const val = miles * rate + (flight.taxARS / (fx || 1)) + profit;
    if (val > 0) {
      // Round to $5 steps by the ones digit: 0-2 -> down, 3-6 -> the middle $5, 7-9 -> up.
      const tens = Math.floor(val / 10) * 10;
      const ones = val - tens;
      const rounded = ones < 3 ? tens : (ones < 7 ? tens + 5 : tens + 10);
      return '$' + rounded;
    }
  }

  return '$';
}
